import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import { getBillingDetail } from "../../../modules/billing/action";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";



class TransactionHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: userDetail().username,
      fetchingComplete: false,
      order: "desc",
      orderBy: "updatedAt",
      headerRows: {
        created: "Date",
        order: "Order ID",
        amount: "Amount",
        last4: "Card Details",
        description: "Description",
        status: "Status"
      },
      dataRows: this.props.BillingDetails
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.BillingDetails &&
      this.props.BillingDetails !== nextProps.BillingDetails &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  componentWillMount() {
    const { username } = this.state;
    username &&
      this.props.actions.getBillingDetail(username).then(data => {
        if (data) {
          const { BillingDetails } = this.props;
          this.craeteRowData(BillingDetails);
        }
      });
  }

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  craeteRowData = rowData => {
    let data =
      rowData &&
      Object.keys(rowData).map(value => {
        let CurrentRow = rowData[value];
        let obj = [];
        var date = new Date(CurrentRow["charge list"].created*1000);
        obj["created"] = CurrentRow["charge list"].created
          ? moment(date).format("ll")
          : "NIL";
        obj["order"] = CurrentRow["charge list"].order
          ? CurrentRow["charge list"].order
          : "NA";
        obj["amount"] = CurrentRow["charge list"].amount
          ? `${CurrentRow["charge list"].currency.toUpperCase()}\xa0${parseFloat(
              CurrentRow["charge list"].amount / 100
            ).toFixed(2)}`
          : "NIL";
        obj["description"] = CurrentRow["charge list"].description
          ? CurrentRow["charge list"].description
          : "NIL";
        obj["last4"] = CurrentRow["charge list"].source
          ? `xxxx\xa0xxxx\xa0xxxx\xa0${CurrentRow["charge list"].source.last4}`
          : "NIL";
        obj["status"] = CurrentRow["charge list"].status
          ? `${CurrentRow["charge list"].status}\xa0\xa0\xa0\xa0\xa0\xa0\xa0`
          : "NIL";

        return obj;
      });
    // return []
    this.setState(
      {
        dataRows: data
      });
  };

  render() {
    const {
      username,
      fetchingComplete,
      order,
      orderBy,
      dataRows = []
    } = this.state;
    const { BillingDetails, ErrorMessage } = this.props;
    return (
      <div className="deep">
        {fetchingComplete ? (
          ErrorMessage && ErrorMessage.message ? (
            <div className="ErrorMessage">{ErrorMessage.message}</div>
          ) : (
            <CreateTable
              orderBy={orderBy}
              order={order}
              onRequestSort={this.handleRequestSort}
              headerRows={this.state.headerRows}
              rowData={dataRows}
              delete={this.deleteRow}
              isMenuRequired={false}
            />
          )
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    BillingDetails: state.billingReducer.BillingDetails,
    ErrorMessage: state.globalserverMessage.ErrorMessage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getBillingDetail
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionHistory);



// WEBPACK FOOTER //
// ./src/components/private/Billing/TransactionHistory.js